import { reviewList } from '@/mocks/homeMock';

export default function Picks() {
  return (
    <section id="picks" className="mx-auto max-w-7xl scroll-mt-20 px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-semibold text-secondary-800">
            <i className="ri-vip-diamond-line" />
            REVIEWS
          </span>
          <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-4xl">深度测评 · 时效比拼</h2>
          <p className="mt-2 text-sm text-foreground-600 md:text-base">不只是抢快，更帮你把瓜吃透、吃明白。</p>
        </div>
      </div>

      <div className="mt-8 grid gap-5 lg:grid-cols-3">
        {reviewList.map((r, idx) => (
          <article key={r.id} className={`group flex flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition hover:border-primary-200 hover:shadow-[0_18px_44px_-26px_rgba(0,0,0,0.3)] ${idx === 0 ? 'lg:row-span-1' : ''}`}>
            <div className="relative h-48 overflow-hidden">
              <img src={r.img} alt={r.title} className="h-full w-full object-cover object-center transition duration-500 group-hover:scale-105" />
              <span className="absolute left-3 top-3 rounded-full bg-background-950/75 px-2.5 py-1 text-xs font-bold text-accent-300 backdrop-blur">
                {r.tag}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="line-clamp-2 font-heading text-lg font-bold leading-snug text-foreground-950 group-hover:text-primary-600">
                {r.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{r.excerpt}</p>
              <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs">
                <span className="inline-flex items-center gap-1 text-foreground-500">
                  <i className="ri-time-line" />
                  {r.minutes}
                </span>
                <span className="inline-flex items-center gap-1 font-bold text-accent-700">
                  <i className="ri-star-fill text-accent-500" />
                  {r.score}
                </span>
                <a href="#topics" className="inline-flex items-center gap-1 text-primary-600 hover:text-primary-500">
                  继续阅读
                  <i className="ri-arrow-right-line" />
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}